module.exports = __webpack_public_path__ + "static/media/IconTemplates_-54.a1d563df.svg";